module.exports = __webpack_public_path__ + "img/App book Leap 30.9 swahili.d13bfe27.png";